import { useState } from "react";

import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { useLista } from "../../../../hooks/useLista";
import AdvancedSearch from "../../../AdvancedSearch";
import InputLista from "../../../InputLista";
import {InputWithEnterEvent} from "../../../index";

const InputTipoMultaFilters = (props) =>  {
    const [formValues, handleInput] = useForm({
        codigo: '', nombre: '', idTipoTributo: 0,
    })
    const [labels, setLabels] = useState([])

    const [, getRowLista ] = useLista({
        listas: ['TipoTributo'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        },
        memo: {
          key: 'TipoTributo',
          timeout: 0,
        },
    })
    const getTipoTributo = (id) => getRowLista('TipoTributo', id) ?? {}

    const onClickSearch = () => {
        props.onSearch(formValues)
        
        const newLabels = []

        if (formValues.codigo !== '') newLabels.push({ title: 'Código', value: formValues.codigo })
        if (formValues.nombre !== '') newLabels.push({ title: 'Nombre', value: formValues.nombre })
        if (props.idTipoTributo && formValues.idTipoTributo !== 0) newLabels.push({
            title: 'Tipo de tributo',
            value: getTipoTributo(formValues.idTipoTributo).nombre
        })

        setLabels(newLabels)
    }

    const inputSize = props.idTipoTributo ? 'col-md-6' : 'col-md-4'

    return (
        <AdvancedSearch labels={labels} onSearch={onClickSearch}>
            <div className='row form-basic'>
                <div className={`col-12 ${inputSize}`}>
                    <label htmlFor="codigo" className="form-label">Código</label>
                    <InputWithEnterEvent
                        name="codigo"
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={formValues.codigo}
                        onChange={handleInput}
                        onEnter={onClickSearch}
                    />
                </div>
                <div className={`col-12 ${inputSize}`}>
                    <label htmlFor="nombre" className="form-label">Nombre</label>
                    <InputWithEnterEvent
                        name="nombre"
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={formValues.nombre}
                        onChange={handleInput}
                        onEnter={onClickSearch}
                    />
                </div>
                {!props.idTipoTributo && (
                    <div className={`col-12 ${inputSize}`}>
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            lista="TipoTributo"
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={formValues.idTipoTributo}
                            onChange={handleInput}
                        />
                    </div>
                )}
            </div>
        </AdvancedSearch>
    )
}

export default InputTipoMultaFilters
